import { labels } from 'presentation/constant/labels'
import { validateOnlyNumber } from 'presentation/utils/format'

export const validateRuc = (
  newValue: string,
  setStateError: any,
  setState: any,
  oldValue: string,
) => {
  if (newValue === '') {
    setStateError(labels.form.requiredFieldText)
  } else if (!validateOnlyNumber(newValue)) {
    setState(oldValue)
  } else if (newValue.length < 13) {
    setStateError(labels.form.wrongRucText)
  } else if (newValue.length > 13) {
    setState(oldValue)
  } else {
    setStateError('')
  }
}
